import { z } from 'zod'

export const zSortDirectionEnum = z.enum(['DESC', 'ASC'])

export type SortDirectionEnumSchema = z.infer<typeof zSortDirectionEnum>

export const SortDirectionEnum = zSortDirectionEnum.enum

export const zSortByEnum = z.enum([
  'NAME_DESC',
  'NAME_ASC',
  'CREATED_DATE_ASC',
  'CREATED_DATE_DESC',
  'NUMBER_ASC', // sort by product id ASC
  'NUMBER_DESC', // sort by product id DESC
])

export type SortByEnumSchema = z.infer<typeof zSortByEnum>

export const SortByEnum = zSortByEnum.enum
